import { render } from "./PartnershipPage.vue?vue&type=template&id=62d4b94a&scoped=true"
import script from "./PartnershipPage.vue?vue&type=script&lang=js"
export * from "./PartnershipPage.vue?vue&type=script&lang=js"

import "./PartnershipPage.vue?vue&type=style&index=0&id=62d4b94a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62d4b94a"]])

export default __exports__